import * as React from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import { Trans } from 'react-i18next'

function DescriptionTexts() {
    const {t} = useTranslation('common');
    return (
        <div id='descriptionsTextsContainer'>
            <span className='noselect'>
                <Trans
                    i18nKey="userMessagesUnread" // optional -> fallbacks to defaults if not provided
                    defaults="<bold>{{twist_text}}</bold>" // optional defaultValue
                    values={{ twist_text: t('TWIST_DESCRIPTION')}}
                    components={{ italic: <i />, bold: <strong /> }}
                >
                </Trans>
            </span>
            <span className='noselect'>
                <span>&nbsp;</span>
                <Trans
                    i18nKey="userMessagesUnread" // optional -> fallbacks to defaults if not provided
                    defaults="<bold>{{move_text}}</bold>" // optional defaultValue
                    values={{ move_text: t('MOVE_DESCRIPTION')}}
                    components={{ italic: <i />, bold: <strong /> }}
                >
                </Trans>
            </span>
            <span className='noselect'>
                <span>&nbsp;</span>
                <Trans
                    i18nKey="userMessagesUnread" // optional -> fallbacks to defaults if not provided
                    defaults="<bold>{{scroll_text}}</bold>" // optional defaultValue
                    values={{ scroll_text: t('SCROLL_DESCRIPTION')}}
                    components={{ italic: <i />, bold: <strong /> }}
                >
                </Trans>
            </span>
        </div>
    )
}

export default withTranslation('common')(DescriptionTexts);
